
/**
 * 인증 제공자
 */
export type SearchUsers200ContentItemProvider = typeof SearchUsers200ContentItemProvider[keyof typeof SearchUsers200ContentItemProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchUsers200ContentItemProvider = {
  LOCAL: 'LOCAL',
  GOOGLE: 'GOOGLE',
  GITHUB: 'GITHUB',
  FACEBOOK: 'FACEBOOK',
} as const;
